module.exports = {"iconDefault":"798d99","iconDark":"6b808c"}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/data/colors.json
// module id = SXGo
// module chunks = 1